'use client';

import type React from 'react';

import classnames from 'classnames';
import {
  FaCircleCheck,
  FaCircleMinus,
  FaRegCircle,
  FaShieldHalved,
} from 'react-icons/fa6';

import type { BaseComponentProps } from '../../base-component.types';
import type {
  DateStreakDayProps,
  DateStreakDayStatus,
} from '../DateStreak.types';

import styles from './DateStreakDay.module.scss';

const STATUS_ICONS: Record<DateStreakDayStatus, React.ComponentType> = {
  disabled: FaCircleMinus,
  skipped: FaShieldHalved,
  highlighted: FaCircleCheck,
  empty: FaRegCircle,
};

function DateStreakDay({
  style,
  className,
  label,
  today,
  status,
  testId = 'ui-date-streak-day',
}: BaseComponentProps & DateStreakDayProps) {
  const Icon = STATUS_ICONS[status];
  const ariaLabel = `${label}${today ? ', today' : ''}, ${status}`;

  return (
    <div
      style={style}
      className={classnames(styles['date-streak-day'], className)}
      data-testid={testId}
      aria-label={ariaLabel}
      role="listitem"
    >
      <span className={styles['date-streak-day__label']}>{label}</span>
      <span
        className={classnames(
          styles['date-streak-day__icon'],
          today && styles['date-streak-day__icon--today'],
          status && styles[`date-streak-day__icon--${status}`],
        )}
        aria-label={status}
      >
        <Icon />
      </span>
    </div>
  );
}

export { DateStreakDay };
